import { apiDelete, apiGet, apiPut } from "./api";

export const getLunchOrders = (onSuccess) => apiGet('/lunch/current/user-order', onSuccess);

export const deleteLunchOrder = (lunchId, orderId, onSuccess) =>
    apiDelete(`/lunch/${lunchId}/user-order/${orderId}`, onSuccess);

export const updateLunchOrder = (lunchId, orderId, order, onSuccess) =>
    apiPut(`/lunch/${lunchId}/user-order/${orderId}`, order, onSuccess);
